import React, {ReactNode} from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import classNames from 'classnames';
import styles from './Navigation.module.scss';

export const CustomLink = ({path, children, shortLabel}:{path: string; children: ReactNode; shortLabel?: string}) => {
    const {pathname} = useLocation();
   const content = shortLabel
        ? (
            <>
                <span className={styles.navigation__labelFull}>{children}</span>
                <span className={styles.navigation__labelShort}>{shortLabel}</span>
            </>
        )
        : children;

    return pathname === path
        ? <span className={classNames(styles.navigation__item, styles.navigation__itemActive)}>{content}</span>
        : <NavLink to={path} className={styles.navigation__item}>{content}</NavLink>;
};
